import { Button } from "@material-ui/core";
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Modal,
  Popover,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import {
  Chat,
  ClockAfternoon,
  EnvelopeSimple,
  MagnifyingGlass,
  Shield,
  User,
  UserPlus,
  UsersThree,
  X,
} from "phosphor-react";
import { useEffect, useState } from "react";
import { fget } from "../../../../API/callsAPI";
import MyTeamCollaboratorsTable from "../../../MyTeamMembersPageComponents/MyTeamCollaboratorsTable";
import ErrorOrSuccessMessage from "../../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import Loader from "../../../Utilities/Loader/Loader";
import InviteUserModal from "../InviteUserModal/InviteUserModal";
import useStyles from "./ManageCollaboratorModal.styles";

export default function ManageCollaboratorModal({
  selectedProject,
  handleClose,
}) {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [orgModalOpen, setOrgModalOpen] = useState(false);
  const [projectModalOpen, setProjectModalOpen] = useState(false);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [isInviteUsersModalOpen, setIsInviteUsersModalOpen] = useState(false);
  const [teamDetails, setTeamDetails] = useState();
  const [isTeamDetailsLoaded, setIsTeamDetailsLoaded] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [projectUsers, setProjectUsers] = useState({});
  const [nameSearchQuery, setNameSearchQuery] = useState("");
  const [isUsersLoading, setIsUsersLoading] = useState(true);
  const [teamUsers, setTeamUsers] = useState({});

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action) => {
    if (action === "org") {
      setOrgModalOpen(true);
    } else if (action === "project") {
      setProjectModalOpen(true);
    } else if (action === "email") {
      setEmailModalOpen(true);
    }
    // Handle other actions here
    console.log("Selected action:", action);
    handlePopoverClose();
  };

  useEffect(() => {
    const handleGetTeamDetails = async () => {
      try {
        if (selectedProject?.project_space?.id) {
          setIsTeamDetailsLoaded(false);
          const res = await fget({
            url: `project-space/${selectedProject?.project_space?.id}`,
          });
          setTeamDetails(res?.data);
          setIsTeamDetailsLoaded(true);
        } else {
          setIsTeamDetailsLoaded(true);
        }
      } catch (error) {
        console.log(error);
      }
    };
    handleGetTeamDetails();
  }, [refreshCounter, selectedProject]);

  useEffect(() => {
    const handler = setTimeout(async () => {
      try {
        // ✅ if empty, load default users
        if (!nameSearchQuery.trim()) {
          const res = await fget({
            url: `project/${selectedProject?.id}/users/`,
          });
          setProjectUsers(res?.data);
          return;
        }

        // ✅ minimum 2 chars before searching
        if (nameSearchQuery.length < 2) return;

        // ✅ debounced search
        const res = await fget({
          url: `project/${selectedProject?.id}/users/?q=${nameSearchQuery}`,
        });
        setProjectUsers(res?.data);
      } catch (error) {
        console.log(error);
      }
    }, 300); // debounce delay (ms)

    // cleanup
    return () => clearTimeout(handler);
  }, [refreshCounter, selectedProject, nameSearchQuery]);

  // ✅ Debounced Search Effect
  useEffect(() => {
    const handler = setTimeout(async () => {
      try {
        setIsUsersLoading(true);

        /* if (selectedProject?.project_space?.id) {
          // ✅ If search is empty, fetch default users
          if (!nameSearchQuery.trim()) {
            const res = await fget({
              url: `project-space/${selectedProject?.project_space?.id}/users`,
            });
            setTeamUsers(res?.data);
            setIsUsersLoading(false);
            return;
          }

          // ✅ Minimum characters
          if (nameSearchQuery.length < 2) {
            setIsUsersLoading(false);
            return;
          }

          // ✅ Debounced API call
          const res = await fget({
            url: `project-space/${selectedProject?.project_space?.id}/users?q=${nameSearchQuery}`,
          });
          setTeamUsers(res?.data);
        } */
        setIsUsersLoading(false);
      } catch (error) {
        console.log(error);
      }
    }, 300);

    return () => clearTimeout(handler);
  }, [refreshCounter, selectedProject?.project_space?.id, nameSearchQuery]);

  const open = Boolean(anchorEl);
  return (
    <Box className={classes.root}>
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <Box className={classes.header}>
        <Box className={classes.headerLeft}>
          <Typography fontSize={24} fontWeight={500}>
            Manage Collaborators
          </Typography>
          <Typography fontSize={24} fontWeight={500} color="#606479">
            {selectedProject?.name}
          </Typography>
          {/* <IconButton
            className={classes.iconButton}
            onClick={handlePopoverOpen}
          >
            <Plus color="#fff" size={20} />
          </IconButton> */}
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            PaperProps={{
              sx: {
                backgroundColor: "#252A38",
                borderRadius: "12px",
                border: "1px solid #3E4759",
                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.25)",
                minWidth: "240px",
                marginTop: "8px",
              },
            }}
          >
            <MenuList sx={{ padding: "8px" }}>
              <MenuItem
                onClick={() => handleMenuItemClick("email")}
                className={classes.menuItem}
              >
                <ListItemIcon className={classes.listIcon}>
                  <EnvelopeSimple size={20} color="#fff" />
                </ListItemIcon>
                <ListItemText
                  primary="Add from Email"
                  className={classes.listText}
                />
              </MenuItem>
              <MenuItem
                onClick={() => handleMenuItemClick("org")}
                className={classes.menuItem}
              >
                <ListItemIcon className={classes.listIcon}>
                  <UsersThree size={20} color="#fff" />
                </ListItemIcon>
                <ListItemText
                  primary="Add from Org"
                  className={classes.listText}
                />
              </MenuItem>
              <MenuItem
                onClick={() => handleMenuItemClick("project")}
                className={classes.menuItem}
              >
                <ListItemIcon className={classes.listIcon}>
                  <ClockAfternoon size={20} color="#fff" />
                </ListItemIcon>
                <ListItemText
                  primary="Add from project space"
                  className={classes.listText}
                />
              </MenuItem>
            </MenuList>
          </Popover>
          {/* <div>
            <Typography>You have 5 seats left</Typography>
            <Typography>View Plan</Typography>
          </div> */}
        </Box>

        <IconButton onClick={handleClose}>
          <X color="#fff" size={30} />
        </IconButton>
      </Box>
      <Typography fontSize="14px" color="#606479">
        Members of your team were automatically added to this project
      </Typography>
      {isTeamDetailsLoaded ? (
        <Box style={{ display: "flex", gap: "16px", height: "100%" }}>
          <Box className={classes.leftSidebarContainer}>
            <Box className={classes.singleSidebarItem}>
              <Typography className={classes.sidebarGrayText}>Team</Typography>
              <Box
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <img
                  src="https://i.ibb.co.com/fVcMNHCd/2d19fb9fe34db9467b7423fc06e5f191deaabcf8.jpg"
                  alt=""
                  style={{
                    height: "20px",
                    width: "20px",
                    borderRadius: "3px",
                  }}
                />
                <Typography>{teamDetails?.name ?? "--"}</Typography>
              </Box>
            </Box>
            <Box className={classes.singleSidebarItem}>
              <Typography className={classes.sidebarGrayText}>
                Created On
              </Typography>
              <Typography>
                {" "}
                {teamDetails &&
                  new Intl.DateTimeFormat("en-US", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }).format(new Date(teamDetails?.created_at ?? ""))}
              </Typography>
            </Box>
            <Box className={classes.singleSidebarItem}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <Shield
                  size={16}
                  style={{ marginRight: "8px" }}
                  className={classes.sidebarGrayText}
                />
                <Typography className={classes.sidebarGrayText}>
                  Admin
                </Typography>
              </Box>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    backgroundColor: "#6C65D9",
                    borderRadius: "50%",
                    color: "black",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  {teamDetails?.admin?.first_name[0].toUpperCase()}
                </div>{" "}
                {teamDetails?.admin?.first_name}
              </div>
            </Box>
            <Box className={classes.singleSidebarItem}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <Chat
                  size={16}
                  style={{ marginRight: "8px" }}
                  className={classes.sidebarGrayText}
                />
                <Typography className={classes.sidebarGrayText}>
                  Reviewer
                </Typography>
              </Box>
              <Typography>{teamDetails?.role_count?.reviewer}</Typography>
            </Box>
            <Box className={classes.singleSidebarItem}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <User
                  size={16}
                  style={{ marginRight: "8px" }}
                  className={classes.sidebarGrayText}
                />
                <Typography className={classes.sidebarGrayText}>
                  Artist
                </Typography>
              </Box>
              <Typography>{teamDetails?.role_count?.user}</Typography>
            </Box>
            <Box className={classes.singleSidebarItem}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <User
                  size={16}
                  style={{ marginRight: "8px" }}
                  className={classes.sidebarGrayText}
                />
                <Typography
                  className={classes.sidebarGrayText}
                  sx={{ fontSize: 14 }}
                >
                  External Reviewer
                </Typography>
              </Box>
              <Typography>{teamDetails?.role_count?.freelancer}</Typography>
            </Box>
          </Box>
          <Box style={{ width: "100%", height: "100%" }}>
            <Box className={classes.header}>
              <Tabs
                value={tab}
                onChange={(e, value) => setTab(value)}
                sx={{
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#6C65D9 !important",
                  },
                }}
              >
                <Tab
                  className={classes.tabs}
                  sx={{ color: tab === 0 ? "#fff !important" : "#606479" }}
                  label={`All (${
                    // (teamDetails?.collaborators?.length || 0) +
                    projectUsers?.count || 0
                  })`}
                />
                {/* <Tab
                  className={classes.tabs}
                  sx={{ color: tab === 1 ? "#fff !important" : "#606479" }}
                  label={`Team (${teamDetails?.collaborators?.length || 0})`}
                /> */}
                <Tab
                  className={classes.tabs}
                  sx={{ color: tab === 2 ? "#fff !important" : "#606479" }}
                  label={`Other Users (${projectUsers?.count ?? 0})`}
                />
              </Tabs>
              <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <Button
                  className={classes.inviteButton}
                  startIcon={<UserPlus />}
                  onClick={() => setIsInviteUsersModalOpen(true)}
                >
                  Invite
                </Button>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    backgroundColor: "#252A38",
                    borderRadius: "10px",
                    width: "200px",
                    padding: "0px 10px",
                  }}
                >
                  <MagnifyingGlass size={20} />
                  <TextField
                    inputProps={{
                      style: {
                        color: "#606479 !important",
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        color: "#fff !important",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                    size="small"
                    fullWidth
                    placeholder="Search in list"
                    value={nameSearchQuery}
                    onChange={(e) => setNameSearchQuery(e.target.value)}
                  />
                </div>
              </Box>
            </Box>
            <Box sx={{ height: "85%", overflowY: "auto" }}>
              {tab === 0 && (
                <MyTeamCollaboratorsTable
                  teamDetails={{
                    // ...teamDetails,
                    // collaborators: teamUsers?.results || [],
                    collaborators: [],
                  }}
                  projectUsers={projectUsers?.results}
                  setRefreshCounter={() =>
                    setRefreshCounter(refreshCounter + 1)
                  }
                  selectedProject={selectedProject}
                  setSnackValue={setSnackValue}
                  hideLeave={true}
                />
              )}
              {tab === 1 && (
                <MyTeamCollaboratorsTable
                  teamDetails={{
                    // ...teamDetails,
                    // collaborators: teamUsers?.results || [],
                    collaborators: [],
                  }}
                  setRefreshCounter={() =>
                    setRefreshCounter(refreshCounter + 1)
                  }
                  selectedProject={selectedProject}
                  setSnackValue={setSnackValue}
                />
              )}
              {tab === 2 && (
                <MyTeamCollaboratorsTable
                  projectUsers={projectUsers?.results}
                  setRefreshCounter={() =>
                    setRefreshCounter(refreshCounter + 1)
                  }
                  selectedProject={selectedProject}
                  setSnackValue={setSnackValue}
                />
              )}
            </Box>
          </Box>
        </Box>
      ) : (
        <Loader />
      )}
      {/* <Box className={classes.footer}>
        <Button variant="contained" className={classes.button}>
          Save
        </Button>
      </Box> */}
      <Modal
        open={isInviteUsersModalOpen}
        onClose={() => setIsInviteUsersModalOpen(false)}
        className={classes.flexCenter}
      >
        <InviteUserModal
          projectId={selectedProject?.id}
          handleRefresh={() => {
            setRefreshCounter(refreshCounter + 1);
            setIsInviteUsersModalOpen(false);
          }}
          inviteType="project"
          setSnackValue={setSnackValue}
        />
      </Modal>
    </Box>
  );
}
